import React from "react";

export const HRReadOnlyBanner = (props) => {
    let { showBanner, message } = props;
    return (
        <React.Fragment>
            {showBanner &&
                <div className="version-update-banner container-fluid">
                <div className="row hr-read-only-banner text-center">
                        <div className="col-12 version-update align-self-center">
                            <div className="banner-message"> {message}
                                <br className="mobile-element" />
                            </div>
                        </div>
                    </div>
                </div>
            }
        </React.Fragment>
    );
}